var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame132(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 339,
    viewBox: "0 0 370 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.931 158.075L483.406 14.9229L232.195 -133.883L228.931 158.075Z",
    stroke: "url(#paint0_linear_64_6557)",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M188.046 227.096L569.025 12.7795L192.933 -210L188.046 227.096Z",
    stroke: "url(#paint1_linear_64_6557)",
    strokeWidth: 20,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_6557",
    x1: 362.897,
    y1: -68.0838,
    x2: 218.738,
    y2: 175.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD71D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_6557",
    x1: 79.0159,
    y1: -51.6727,
    x2: 484.913,
    y2: 188.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD71D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame132);
export default __webpack_public_path__ + "static/media/Frame 132.32498db29191e39df97826ea3759c73a.svg";
export { ForwardRef as ReactComponent };